import type { Currency } from '~/types/api'

export const BUDGET_FLOOR = 0
export const BUDGET_CEILING = 8000

/** What the shopper is looking for, built up across the guided-search screens. */
export interface SearchBrief {
  query: string | null
  categorySlug: string | null
  categoryName: string | null
  /** Human summary for the confirm screen, e.g. "Smart Television, 80”" */
  summary: string | null
  options: string[]
  budgetMin: number
  budgetMax: number
  currency: Currency
}

const empty = (): SearchBrief => ({
  query: null,
  categorySlug: null,
  categoryName: null,
  summary: null,
  options: [],
  budgetMin: BUDGET_FLOOR,
  budgetMax: BUDGET_CEILING,
  currency: 'GBP',
})

/**
 * Cookie-backed so the brief survives the login redirect and full SSR reloads
 * between steps (search → size → budget → summary → login → results).
 */
export function useSearchBrief() {
  const brief = useCookie<SearchBrief>('regotiate-brief', {
    default: empty,
    watch: true, // deep — persists nested edits like brief.options
    sameSite: 'lax',
    maxAge: 60 * 60 * 24,
  })
  // GBP only — drop currencies stored by older sessions
  if (brief.value.currency !== 'GBP') brief.value.currency = 'GBP'

  function start(partial: Partial<SearchBrief>) {
    brief.value = { ...empty(), ...partial }
  }

  return { brief, start }
}
